import { faShoePrints } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';
import { Onboarding } from '../organisms/Onboarding';

export type IOnboardingPageProps = {
  organizationId?: string;
  appId?: string;
};

export const OnboardingPage: React.FC<IOnboardingPageProps> = (props) => {
  const { organizationId: organizationIdProp, appId } = props;
  const { t } = useTranslation();
  const appQuery = useAppQuery(appId ? { appId } : undefined);
  const organizationId = organizationIdProp ?? appQuery.data?.organization?._id;
  const target = appId
    ? 'application'
    : organizationId
      ? 'organization'
      : 'user';

  return (
    <>
      <Helmet>
        <title>{t('OnboardingPage.seo.title')}</title>
      </Helmet>

      <Heading
        title={
          target === 'organization'
            ? t('OnboardingPage.title.organization')
            : target === 'application'
              ? t('OnboardingPage.title.application')
              : t('OnboardingPage.title.user')
        }
        icon={<FontAwesomeIcon icon={faShoePrints} />}
        subtitle={t('OnboardingPage.subtitle')}
      />

      <Onboarding organizationId={organizationId} appId={appId} />
    </>
  );
};
